import { render, staticRenderFns } from "./BotUserSearch.vue?vue&type=template&id=c9532ad4"
import script from "./BotUserSearch.vue?vue&type=script&lang=js"
export * from "./BotUserSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports